import { AudiencePage } from "@/components/audience-page";
import { FOR_SMALL_BUSINESS_FAQ_KEYS } from "@/pages/for-small-business-content";

export function ForSmallBusinessComponent() {
  return (
    <AudiencePage audience="smallBusiness" faqs={FOR_SMALL_BUSINESS_FAQ_KEYS} />
  );
}
